"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SbDropdownHeader = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactIntl = require("react-intl");

var _isEqual = _interopRequireDefault(require("lodash/isEqual"));

var _classnames = _interopRequireDefault(require("classnames"));

var _shapes = require("../../skybase-core/shapes");

var _shapes2 = require("./shapes");

var _sbDropdownI18n = require("./sb-dropdown-i18n");

var _utils = require("./utils");

var _constants = require("../sb-select-option/constants");

var _shapes3 = require("../sb-select-option/shapes");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _SbDropdownHeader = /*#__PURE__*/function (_Component) {
  _inherits(_SbDropdownHeader, _Component);

  var _super = _createSuper(_SbDropdownHeader);

  function _SbDropdownHeader(props) {
    var _this;

    _classCallCheck(this, _SbDropdownHeader);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "createHiddenHeading", function (displayedText) {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "sb-dropdown-dummy-heading"
      }, /*#__PURE__*/_react.default.createElement("span", {
        ref: function ref(node) {
          _this.hiddenHeading = node;
        }
      }, displayedText));
    });

    _defineProperty(_assertThisInitialized(_this), "createHeadingFromOption", function (option) {
      var _ref2, _this$getNameFromOpti;

      var _this$props = _this.props,
          id = _this$props.id,
          defaultTitle = _this$props.title;

      var _ref = option !== null && option !== void 0 ? option : {},
          iconClass = _ref.iconClass;

      if (!option) {
        return defaultTitle;
      }

      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, iconClass && /*#__PURE__*/_react.default.createElement("i", {
        className: (0, _classnames.default)('option-icon header-icon', iconClass)
      }), (_ref2 = (_this$getNameFromOpti = _this.getNameFromOption(option)) !== null && _this$getNameFromOpti !== void 0 ? _this$getNameFromOpti : _this.renderOptionsAsObjects(option, id)) !== null && _ref2 !== void 0 ? _ref2 : defaultTitle);
    });

    _defineProperty(_assertThisInitialized(_this), "createMultipleOptionsHeading", function (options) {
      var _this$props2 = _this.props,
          title = _this$props2.title,
          id = _this$props2.id;

      if (!(options === null || options === void 0 ? void 0 : options.length)) {
        return title;
      }

      if (_this.scanForNonStrings(options)) {
        return options.map(function (option) {
          return _this.getNameFromOption(option);
        }).join(',');
      }

      return options.map(function (option) {
        return /*#__PURE__*/_react.default.createElement("span", {
          key: "".concat(id, "-").concat(option.value)
        }, _this.getNameFromOption(option) || _this.renderOptionsAsObjects(option, id));
      }).reduce(function (prev, curr) {
        return [prev, ',', curr];
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getNameFromOption", function (option) {
      var _option$props;

      return ((_option$props = option.props) === null || _option$props === void 0 ? void 0 : _option$props.children) || option.title || option.label || option.name || null;
    });

    _defineProperty(_assertThisInitialized(_this), "scanForNonStrings", function (options) {
      return options.findIndex(function (option) {
        return !_this.getNameFromOption(option);
      }) === -1;
    });

    _defineProperty(_assertThisInitialized(_this), "renderOptionsAsObjects", function (option, id) {
      return (option === null || option === void 0 ? void 0 : option.options) ? _react.default.Children.map(option.options, function (opt, idx) {
        return _objectSpread(_objectSpread({}, opt), {}, {
          key: "".concat(id, "-").concat(option.value, "-").concat(idx)
        });
      }) : null;
    });

    _this.state = {
      titleWidth: 0
    };
    _this.hiddenHeading = null; // stored to measure the width of the text

    return _this;
  } // catches infinite re-rendering caused by setting state in componentDidUpdate.


  _createClass(_SbDropdownHeader, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      var titleWidth = this.state.titleWidth;
      var nextTitleWidth = nextState.titleWidth;

      var _this$props3 = this.props,
          intl = _this$props3.intl,
          restProps = _objectWithoutProperties(_this$props3, ["intl"]);

      var nextIntl = nextProps.intl,
          nextRestProps = _objectWithoutProperties(nextProps, ["intl"]);

      return titleWidth !== nextTitleWidth || !(0, _isEqual.default)(restProps, nextRestProps);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.hiddenHeading) {
        var width = this.hiddenHeading.offsetWidth;

        if (width !== prevState.titleWidth) {
          // eslint-disable-next-line react/no-did-update-set-state
          this.setState({
            titleWidth: width
          });
        }
      }
    }
    /*
      Creates an invisible small div, that renders the whole text, which should be displayed.
      In ComponentDidUpdate then the width of the div is caught and if it is different than previous one (text has changed),
      then it forces another render, that corrects the displayedText in button.
    */

  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          options = _this$props4.options,
          selected = _this$props4.selected,
          _ = _this$props4.intl.formatMessage,
          displayedTextWidth = _this$props4.displayedTextWidth,
          mode = _this$props4.mode,
          customBody = _this$props4.customBody,
          title = _this$props4.title;
      var titleWidth = this.state.titleWidth;

      if (customBody) {
        return title;
      }

      var selectedOptions = (0, _utils.findOptionBySelected)({
        options: Array.isArray(options) ? options : [options],
        selected: selected
      });
      var displayedText = Array.isArray(selectedOptions) ? this.createMultipleOptionsHeading(selectedOptions) : this.createHeadingFromOption(selectedOptions);
      var hiddenText = displayedText; // creates a local copy of displayedText that is used in creating HiddenHeading. The actual displayedText might be changed in code below.

      if (displayedTextWidth < titleWidth && mode === _constants.MODE.CHECKBOX && (selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.length)) {
        // crucial part in which a decision is made (whether to use either 'X options' or display all the options.
        // it's applicable only on multiSelect dropdowns with at least 1 option selected. Otherwise it displays default title.
        displayedText = _(_sbDropdownI18n.messages.optionsSelected, {
          optionCount: selectedOptions.length
        });
      }

      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, this.createHiddenHeading(hiddenText), displayedText);
    }
  }]);

  return _SbDropdownHeader;
}(_react.Component);

_defineProperty(_SbDropdownHeader, "propTypes", {
  intl: _shapes.intlShape.isRequired,
  selected: _shapes2.selectedShape,
  options: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.object), _propTypes.default.object]),
  title: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]),
  displayedTextWidth: _propTypes.default.number,
  multiSelect: _propTypes.default.bool,
  mode: _shapes3.modeShape,
  id: _propTypes.default.string,
  customBody: _propTypes.default.bool
});

_defineProperty(_SbDropdownHeader, "defaultProps", {
  selected: [],
  options: [],
  title: '',
  displayedTextWidth: 0,
  multiSelect: false,
  mode: _constants.MODE.RADIO,
  id: null,
  customBody: false
});

var SbDropdownHeader = (0, _reactIntl.injectIntl)(_SbDropdownHeader);
exports.SbDropdownHeader = SbDropdownHeader;
//# sourceMappingURL=sb-dropdown-header.js.map